export function policyNumberSerial(value) {
  if (!value) return 0;
  const normalized = String(value).replace(/-/g, '/');
  const parts = normalized.split('/').filter(Boolean);
  if (parts.length >= 2) {
    const maybeYear = parts[parts.length - 1];
    if (/^\d{4}$/.test(maybeYear)) {
      const serial = parseInt(parts[parts.length - 2], 10);
      if (!Number.isNaN(serial)) return serial;
    }
  }
  const digits = normalized.replace(/\D/g, '');
  if (digits.length >= 4) {
    return parseInt(digits.slice(-6), 10) || 0;
  }
  return 0;
}

export function policyRecencyKey({
  quoteId, policyNumber, policyNo, batchNo, coverFrom,
}) {
  const serial = policyNumberSerial(policyNumber || policyNo);
  if (serial > 0) return serial;
  if (batchNo != null) return Number(batchNo) || 0;
  if (quoteId != null) return Number(quoteId) || 0;
  if (coverFrom) {
    const parsed = Date.parse(coverFrom);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
}

export function sortByRecency(items, mapper) {
  return [...items].sort((a, b) => mapper(b) - mapper(a));
}

export function maxRecency(items, mapper) {
  if (!items.length) return 0;
  return Math.max(...items.map(mapper));
}

function focusSlug(value) {
  return String(value || '').trim().replace(/[/\s]+/g, '-');
}

export function policyFocusId(type, policy) {
  if (!policy) return '';
  switch (type) {
    case 'travel':
      return policy.quoteId ? `travel-${policy.quoteId}` : '';
    case 'pa':
      return policy.quoteId
        ? `pa-${policy.quoteId}`
        : `pa-${focusSlug(policy.policyNumber)}`;
    case 'motor':
      return `motor-${focusSlug(policy.policyNo)}`;
    case 'dp':
      return `dp-${focusSlug(policy.policyNo)}`;
    case 'health':
      return `health-${focusSlug(policy.policyNo)}`;
    default:
      return '';
  }
}

export function motorRecencyKey(policy) {
  return policyRecencyKey({
    policyNo: policy.policyNo,
    batchNo: policy.batchNo,
    coverFrom: policy.wef || policy.coverFrom,
  });
}

export function paRecencyKey(policy) {
  const quoteKey = policy.quoteId != null ? Number(policy.quoteId) : 0;
  const detailKey = policyRecencyKey({
    policyNumber: policy.policyNumber,
    coverFrom: policy.coverFrom,
  });
  return Math.max(quoteKey, detailKey);
}

export function travelRecencyKey(policy) {
  const quoteKey = policy.quoteId != null ? Number(policy.quoteId) : 0;
  const detailKey = policyRecencyKey({
    policyNumber: policy.tqPolicyNumber || policy.mapfrePolicyNumber,
    coverFrom: policy.travelStartDate,
  });
  return Math.max(quoteKey, detailKey);
}

export function healthRecencyKey(policy) {
  return policyRecencyKey({
    policyNo: policy.policyNo,
    coverFrom: policy.coverStartDate,
  });
}

export function dpRecencyKey(policy) {
  return policyRecencyKey({
    policyNo: policy.policyNo,
    batchNo: policy.batchNo,
    coverFrom: policy.wef || policy.coverFrom,
  });
}

export function myPoliciesRoute(type, policy) {
  const focus = policyFocusId(type, policy);
  if (type === 'motor' && policy?.policyNo) {
    return { name: 'SinglePolicy', params: { policyNo: policy.policyNo } };
  }
  if (!focus) return { name: 'MyPolicies' };
  return { name: 'MyPolicies', query: { focus } };
}

/** One latest policy per product group, then newest groups first. */
export function buildPolicyPreview(...groups) {
  return groups
    .map((group) => {
      if (!Array.isArray(group) || !group.length) return null;
      return [...group].sort((a, b) => b.sortKey - a.sortKey)[0];
    })
    .filter(Boolean)
    .sort((a, b) => b.sortKey - a.sortKey)
    .map(({ sortKey, ...row }) => row);
}
